// This file gives tools to guard against sending data before the module has been initiated

// Hoist the resolve function of initPromise, so it can be called externally:
let resolveInit: () => void;
let initPromise: Promise<any> = new Promise((resolve) => resolveInit = resolve);

// Delivers a promise the rest of the utility can wait on, to avoid sending events before init:
export const getInitPromise = () => initPromise;

let initialized: boolean = false;
export const isInitialized = () => initialized;

// Resolve the initPromise, signalling to AF that events can now be sent:
export const allowSends = () => {
    initialized = true;
    resolveInit();
};

// A reset switch allows for unit testing:
export const resetSendGate = () => {
    initialized = false;
    initPromise = new Promise((resolve) => resolveInit = resolve);
};
